import { usePage } from '@inertiajs/react'
import Button from '@arianna/design-system/Button'
import Text from '@arianna/design-system/Text'

interface StudentLayoutProps {
  children: React.ReactNode
}

// usePage requires props to have an index signature; we cast to access shared props.
interface AppPageProps {
  current_user?: { id: number; email: string } | null
  [key: string]: unknown
}

export default function StudentLayout({ children }: StudentLayoutProps) {
  const { current_user } = usePage<AppPageProps>().props

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      {/* Header */}
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-4)',
          padding: '0 var(--space-6)',
          height: 54,
          borderBottom: '1px solid var(--line)',
          background: 'var(--bg)',
          flexShrink: 0,
        }}
      >
        {/* Brand */}
        <a
          href="/library"
          style={{
            fontFamily: 'var(--font-serif)',
            fontSize: 18,
            fontWeight: 600,
            color: 'var(--ink)',
            textDecoration: 'none',
            letterSpacing: '-0.02em',
            flex: 1,
          }}
        >
          Arianna
        </a>

        {/* User info + logout */}
        {current_user && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-3)',
            }}
          >
            <Text
              variant="meta"
              style={{
                color: 'var(--ink-3)',
                fontFamily: 'var(--font-sans)',
                fontSize: 12,
              }}
            >
              {current_user.email}
            </Text>
            <form method="post" action="/users/sign_out" style={{ margin: 0 }}>
              <input type="hidden" name="_method" value="delete" />
              <input
                type="hidden"
                name="authenticity_token"
                value={
                  (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)
                    ?.content ?? ''
                }
              />
              <Button type="submit" variant="ghost" size="sm">
                Esci
              </Button>
            </form>
          </div>
        )}
      </header>

      {/* Main content */}
      <main style={{ flex: 1 }}>{children}</main>
    </div>
  )
}
